import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectDoorToDoorPartner, selectIsDoorToDoorPartner } from '@/store/PageConfiguration/PageConfigurationSelectors'
import { selectDoorToDoorPartnerChecklist } from '../../SubscriptionForm/SubscriptionFormSelectors'
import {
  updateDoorToDoorPartnerChecklistCheckedTitle,
  toggleDoorToDoorPartnerChecklistExpanded
} from '../../SubscriptionForm/SubscriptionFormSlice'

const useDoorToDoorPartnerChecklist = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isDoorToDoorPartner = useSelector(selectIsDoorToDoorPartner)
  const partner = useSelector(selectDoorToDoorPartner)
  const { checkedTitles, expanded } = useSelector(selectDoorToDoorPartnerChecklist)

  const allTitlesChecked = Object.values(checkedTitles).every(Boolean)
  const doorToDoorPartnerChecklistCompleted = !isDoorToDoorPartner || allTitlesChecked

  const setCheckedTitle = (key, checked) => dispatch(updateDoorToDoorPartnerChecklistCheckedTitle({ key, checked }))
  const toggleExpanded = key => dispatch(toggleDoorToDoorPartnerChecklistExpanded(key))

  const partnerName = partner?.partnerName ?? ''
  const partnerShortName = partner?.partnerShortName ?? ''
  const i18nVars = { partnerName, partnerShortName }

  const introductionChecklist = {
    title: t('subscriptionForm:door_to_door_partner_checklist.introduction_checklist.title', i18nVars),
    items: [
      t('subscriptionForm:door_to_door_partner_checklist.introduction_checklist.condition_1', i18nVars)
    ]
  }

  const identityChecklist = {
    title: t('subscriptionForm:door_to_door_partner_checklist.identity_checklist.title', i18nVars),
    items: [
      t('subscriptionForm:door_to_door_partner_checklist.identity_checklist.condition_1', i18nVars),
      t('subscriptionForm:door_to_door_partner_checklist.identity_checklist.condition_2', i18nVars)
    ]
  }

  const presentationChecklist = {
    title: t('subscriptionForm:door_to_door_partner_checklist.presentation_checklist.title', i18nVars),
    items: [
      t('subscriptionForm:door_to_door_partner_checklist.presentation_checklist.condition_1', i18nVars)
    ]
  }

  const visitPurposeChecklist = {
    title: t('subscriptionForm:door_to_door_partner_checklist.visit_purpose_checklist.title', i18nVars),
    items: [
      t('subscriptionForm:door_to_door_partner_checklist.visit_purpose_checklist.condition_1', i18nVars)
    ]
  }

  const recapChecklist = {
    title: t('subscriptionForm:door_to_door_partner_checklist.recap_checklist.title', i18nVars),
    items: [
      t('subscriptionForm:door_to_door_partner_checklist.recap_checklist.condition_1', i18nVars),
      t('subscriptionForm:door_to_door_partner_checklist.recap_checklist.condition_2', i18nVars),
      t('subscriptionForm:door_to_door_partner_checklist.recap_checklist.condition_3', i18nVars)
    ]
  }

  return {
    isDoorToDoorPartner,
    introductionChecklist,
    identityChecklist,
    presentationChecklist,
    visitPurposeChecklist,
    recapChecklist,
    checkedTitles,
    expanded,
    setCheckedTitle,
    toggleExpanded,
    doorToDoorPartnerChecklistCompleted
  }
}

export default useDoorToDoorPartnerChecklist
